import {h, Fragment} from "preact"
import { useActions, useAppState, useProductFilters } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { defaultConfig, sortOptions } from "../config"

import Sidebar from "./Sidebar"
import Facet from "./Facet"

function FacetComponent({ facets, active, setActive }) {
    const [tooltip, setTooltip] = useState("")

    const { filters, removeAll } = useProductFilters()
    const { updateSearch, replaceFilter } = useActions()

    const initialSelected = facets[0].data?.find(el => el.selected === true)?.value.toLowerCase() || '';

    const [selected, setSelected] = useState(initialSelected)

    const handleSelection = (facetValue) => {
        replaceFilter(facets[0].field, facetValue)
        setSelected(facetValue.toLowerCase())
    }

    const isMobile = window.innerWidth < 769;

    return (
        <div class="collecton-filter__item collection-filter__item--color" style="display:none">
            {!isMobile && <span class={!active ? "ns-tooltip ns-absolute ns-d-none" : "ns-tooltip ns-absolute"}>{tooltip}</span>}
            <ul class={!active ? "ns-list-unstyled ns-p-0 ns-m-0 tag-filters ns-d-none" : "ns-list-unstyled ns-p-0 ns-m-0 tag-filters"}>
                <li class={(selected !== null && selected === "ALL COLORS") ? "tag-filters__item active" : "tag-filters__item"}>
                    <span
                        style={`background: linear-gradient(122.47deg, #EA9EF0 16.53%, #89EAFF 48.26%, #EBFF00 87.36%)`}
                        title="all colors"
                        onClick={() => {
                            setSelected("ALL COLORS")
                            removeAll();
                            setActive(false)
                        }}
                        onMouseOver={() => setTooltip("ALL COLORS")}>ALL COLORS</span></li>
                {facets[0].data?.map((value, index) => {
                    const colorValue = value.value.toLowerCase();

                    return <li class={(selected !== null && selected === colorValue) ? "tag-filters__item active" : "tag-filters__item"}>

                        <span
                            style={`${colorValue !== "prints" ? `background: var(--tag-${colorValue})` : "background-image: url('https://www.emijay.com/cdn/shop/t/45/assets/tag_print_small.jpg?v=183066468511784898811705367221')"}`}
                            title={colorValue}
                            onClick={() => handleSelection(colorValue)}
                            onMouseOver={() => setTooltip(colorValue)}>{colorValue}</span>
                    </li>
                })}
            </ul>
        </div>
    )
}



export default function ({ mobile }) {
    const { loading, query, response, response: { products: { facets } } = {}, pageType } = useAppState()
    const { updateSearch } = useActions()

    const [active, setActive] = useState(false);

    const activeSort =
        sortOptions.find(option =>
            option.value.sort.every(v1 =>
                query.products?.sort?.find(
                    v2 => v1.field === v2.field && v1.order === v2.order
                )
            )
        )?.id ?? defaultConfig.sort.id


    return (


            <div class="collection-filter" style="display:none">

                <div class="collection-filter__item--color-label" tabindex="0">
                    <div class="collection-filter__color-label-container">
                        <a
                            class="ns-d-flex ns-align-items-center ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                            href="javascript:void(0)"
                            data-nosto-element="facet"
                            onClick={() => {
                                setActive(!active)
                            }}
                        >
                            <span class="ns-all-colors"></span>
                            {/* <span class="ns-facet-name">{filters.length === 0 ? facets[0].name : "Color: "}</span> */}
                            <span class="ns-facet-name">{facets[0].name}</span>
                        </a>

                    </div>
                </div>
                {!mobile && <FacetComponent
                    facets={facets}
                    active={active}
                    setActive={setActive} />}
                <div class="collection-filter__item collection-filter__item--sort">
                    <select
                        name="ns-sort-dropdown"
                        id="ns-sort-dropdown"
                        class="ns-selection-dropdown-menu ns-selection-dropdown-sort-menu ns-text-align-left"
                        value={activeSort}
                        onChange={e => {
                            updateSearch({
                                products: {
                                    sort: sortOptions.find(
                                        v => v.id === e?.target?.value
                                    )?.value?.sort,
                                },
                            })
                        }}
                        style="background-image: url('https://www.emijay.com/cdn/shop/t/45/assets/ico-select.svg'); 
                        background-repeat: no-repeat;
                        background-position: right 10px center;
                        background-size: 11px;"
                    >
                        {sortOptions.map(o => (
                            <option value={o.id}>{o.value.name}</option>
                        ))}
                    </select>
                </div>
            
            {mobile && <FacetComponent
                facets={facets}
                active={active}
                setActive={setActive} />}
        </div>
    )
}
